import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const TendersEditor = () => {
  const columns = [
    { key: 'title-en', label: 'Title (EN)', type: 'text' },
    { key: 'title-ms', label: 'Title (MS)', type: 'text' },
    { key: 'description-en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'status', label: 'Status', type: 'select', options: [
      { value: 'open', label: 'Open' },
      { value: 'closed', label: 'Closed' },
    ] },
    { key: 'link', label: 'Explore Link', type: 'text' },
  ];

  return <GenericTableEditor tableName="tenders" columns={columns} title="Tenders Manager" />;
};

export default TendersEditor;
